const toTwoDecimalPlaces = (x: number): number =>
  Number(`${Math.round(Number(`${x}e2`))}e-2`)

export default toTwoDecimalPlaces
